import React from 'react';

import { Box } from '@components/Restyle';
import { Skeleton } from '@components/shared/Skeleton';

// Mirrors InvoiceTab.web.tsx's TABLE_FLEX column widths (date / description /
// amount / status / action) so the skeleton lines up with the real header.
const TABLE_FLEX = [23, 38, 23, 10, 6] as const;

/**
 * Team Detail Invoice tab row placeholder — date / description / amount /
 * status columns, matching `InvoiceTab.web.tsx`'s `InvoiceRow` height (48).
 */
export const InvoiceRowSkeleton: React.FC<{ testID?: string }> = ({
  testID = 'invoice-row-skeleton',
}) => {
  return (
    <Box
      testID={testID}
      flexDirection='row'
      alignItems='center'
      height={48}
      paddingHorizontal='m'>
      <Box flex={TABLE_FLEX[0]} paddingHorizontal='m'>
        <Skeleton variant='text' width='60%' />
      </Box>
      <Box flex={TABLE_FLEX[1]} paddingHorizontal='m'>
        <Skeleton variant='text' width='70%' />
      </Box>
      <Box flex={TABLE_FLEX[2]} paddingHorizontal='m'>
        <Skeleton variant='text' width='40%' />
      </Box>
      <Box flex={TABLE_FLEX[3]} paddingHorizontal='m'>
        <Skeleton variant='rect' width={45} height={18} borderRadius='xxs' />
      </Box>
      <Box flex={TABLE_FLEX[4]} />
    </Box>
  );
};
